import {FeInputFieldStatus} from '@modifi/enums'
import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS} from '../../../constants/sections'
import {selectCombinedInputFieldStatusBySectionName} from '../../../modules/input-fields'
import {selectMandateStatusByExternalId} from '../../../data/direct-debit-account'
import {
  selectInitialFormData,
  aSavePage,
  selectSaveErrorMessage,
  selectSavePending,
  selectSaveErrorFieldErrors,
  aClearError,
  aInitializePage,
} from './store'

import DirectDebitAccount, {DirectDebitAccountProps} from './DirectDebitAccount'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: Record<string, any>
): Pick<
  DirectDebitAccountProps,
  | 'externalBankAccountId'
  | 'initialFormData'
  | 'errorMessage'
  | 'updatePending'
  | 'pageIsVerified'
  | 'mandateStatus'
  | 'externalErrorMessages'
> => {
  const externalBankAccountId = ownProps?.match?.params?.externalBankAccountId
  return {
    externalBankAccountId,
    initialFormData: selectInitialFormData(state, externalBankAccountId),
    // initialFormDataLoading: !selectDirectDebitBankAccountsWhereLoaded(state),
    errorMessage: selectSaveErrorMessage(state),
    updatePending: selectSavePending(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_DIRECT_DEBIT_ACCOUNT_DETAILS) ===
      FeInputFieldStatus.VERIFIED,
    // @ts-expect-error  redux type issue
    externalErrorMessages: selectSaveErrorFieldErrors(state),
    // currentExternalBankAccountId,
    mandateStatus: selectMandateStatusByExternalId(state, externalBankAccountId),
  }
}

const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSavePage,
  clearError: aClearError,
  redirect: aPush,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(DirectDebitAccount)
